
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { saveAs } from 'file-saver';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HelpService } from './../../api/help.service';
@UntilDestroy()
@Component({
  selector: 'iv-download-docs',
  templateUrl: './download-docs.component.html',
  styleUrls: ['./download-docs.component.scss']
})
export class DownloadDocsComponent implements OnInit, OnDestroy {
  files = [];
  downloadInProgress = true;
  showError = false;

  constructor(public dialogRef: MatDialogRef<DownloadDocsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private helpService: HelpService) {
    this.files = [];
    this.downloadInProgress = true;
    this.showError = false;
  }

  ngOnInit() {
    this.files.push({ 'fileName': this.data.fileName });
    this.invokeTrainingDocumentsAPI();
    this.getData();
  }

  invokeTrainingDocumentsAPI() {
    this.helpService.downloadDocumentsSubject.next(true);
  }

  getData() {
    this.helpService.trainingResponseSubject.asObservable()
      .pipe(untilDestroyed(this))
      .subscribe((response: any) => {
        if (response) {
          const blob = new Blob([response], {
            type: 'application/zip'
          });
          saveAs(blob, this.data.fileName);
          this.downloadInProgress = false;
        } else {
          this.showError = true;
          this.downloadInProgress = false;
        }
      });
  }

  ngOnDestroy() {
  }
}
